import React, { useState, useEffect } from 'react';
import RegistrationForm from './components/RegistrationForm';
import LanguageSelector from './components/LanguageSelector';
import logo from './assets/logo.svg';
import { translations, detectLanguage, setLanguage } from './i18n';
import './App.css';

function App() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState('fr');

  useEffect(() => {
    const detectedLang = detectLanguage();
    setCurrentLanguage(detectedLang);
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setCurrentLanguage(lang);
  };

  const handleSubmitSuccess = () => {
    setIsSubmitted(true);
  };

  const t = translations[currentLanguage];

  return (
    <div className="App">
      <div className="container">
        <div className="logo-container">
          <img src={logo} alt="QualiteeMed" className="logo-image" />
        </div>
        {!isSubmitted ? (
          <RegistrationForm 
            onSuccess={handleSubmitSuccess} 
            currentLanguage={currentLanguage}
            onLanguageChange={handleLanguageChange}
          />
        ) : (
          <div className="form-container">
            <div className="success-message">
              <h2>{t.successTitle}</h2>
              <p>{t.successMessage}</p>
              <div className="back-to-website">
                <a href="https://qualiteemed.ai/" className="website-link">
                  {t.backToWebsite}
                </a>
              </div>
            </div>
            <div className="help-section">
              <div className="help-title">{t.helpTitle}</div>
              <div className="help-text">
                {t.helpDescription}
              </div>
              <div className="help-text">
                📧 <a href={`mailto:${t.helpEmail}`} className="help-contact">{t.helpEmail}</a>
              </div>
              <div className="help-text">
                📞 <a href={`tel:+41419215888`} className="help-contact">{t.helpPhone}</a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
